import { render, staticRenderFns } from "./OrderFormStep4.module.vue?vue&type=template&id=98e99206&scoped=true&"
import script from "./OrderFormStep4.module.vue?vue&type=script&lang=js&"
export * from "./OrderFormStep4.module.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormStep4.module.vue?vue&type=style&index=0&id=98e99206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e99206",
  null
  
)

export default component.exports